import { Button, Affix } from 'antd';
import styled from 'styled-components';

import { roundedCorners, defaultBorder } from 'styles/reuse';

export const Bar = styled.div`
  ${roundedCorners};
  ${defaultBorder};
  width: 100%;
  background: #ffffff;
  height: fit-content;
  padding: 10px 0px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
`;

export const Container = styled(Affix).attrs({
  offsetTop: 57,
  style: {
    width: '100%',
    marginTop:
      document.getElementsByTagName('body')[0].clientWidth > 1080 ? 80 : 0,
  },
})``;

export const MenuButton = styled(Button)`
  border: 0;
  width: 60px;
  box-shadow: none;
  display: flex;
  align-content: center;
  justify-content: center;
  .anticon {
    font-size: 20px;
    line-height: 0px;
  }
`;
